const deliveringActions = {
    types: {
        DELIVERING_CHECK_STORED_ITEMS_COMPARE_SUCCESS: 'DELIVERING_CHECK_STORED_ITEMS_COMPARE_SUCCESS',
        DELIVERING_CHECK_STORED_ITEMS_COMPARE_FAILED: 'DELIVERING_CHECK_STORED_ITEMS_COMPARE_FAILED',
        DELIVERING_RESET_DELIVER_STATE: 'DELIVERING_RESET_DELIVER_STATE',
        DELIVERING_SET_ACTION_IN_PROGRESS: 'DELIVERING_SET_ACTION_IN_PROGRESS',
        DELIVERING_SET_HAS_DELIVERED: 'DELIVERING_SET_HAS_DELIVERED',
        DELIVERING_ADD_PENDING_OFFLINE_DELIVERY: 'DELIVERING_ADD_PENDING_OFFLINE_DELIVERY',
        DELIVERING_REMOVE_PENDING_OFFLINE_DELIVERY: 'DELIVERING_REMOVE_PENDING_OFFLINE_DELIVERY',
        DELIVERING_SET_OFFLINE_FILE_DELIVERY_STATUS: 'DELIVERING_SET_OFFLINE_FILE_DELIVERY_STATUS',
        DELIVERING_SET_OFFLINE_FILE_DELIVERY_OBJECT: 'DELIVERING_SET_OFFLINE_FILE_DELIVERY_OBJECT',
    },

    statuses: {
        DOWNLOADED: 'DOWNLOADED',
        COMPLETE: 'COMPLETE',
        ERRORED: 'ERRORED',
        PENDING: 'PENDING',
        TRYING_TO_UPLOAD: 'TRYING_TO_UPLOAD',
    },

    progressActions: {
        SUBMIT: 'SUBMIT',
        WITHDRAW: 'WITHDRAW',
        DELIVER_BLANK: 'DELIVER_BLANK',
    },

    checkStoredItemsCompareSuccess(storedItemsStatus) {
        return { type: this.types.DELIVERING_CHECK_STORED_ITEMS_COMPARE_SUCCESS, storedItemsStatus };
    },

    checkStoredItemsCompareFailed(storedItemsStatus, differences) {
        return { type: this.types.DELIVERING_CHECK_STORED_ITEMS_COMPARE_FAILED, storedItemsStatus, differences };
    },

    resetDeliveringState() {
        return { type: this.types.DELIVERING_RESET_DELIVER_STATE };
    },

    setActionInProgress(actionInProgress) {
        return { type: this.types.DELIVERING_SET_ACTION_IN_PROGRESS, actionInProgress };
    },

    setHasDelivered(hasDelivered) {
        return { type: this.types.DELIVERING_SET_HAS_DELIVERED, hasDelivered };
    },

    setOfflineFileDeliveryStatus(assessmentRunId, status) {
        return { type: this.types.DELIVERING_SET_OFFLINE_FILE_DELIVERY_STATUS, assessmentRunId, status };
    },

    setOfflineFileDeliveryObject(assessmentRunId, deliveryObject) {
        return { type: this.types.DELIVERING_SET_OFFLINE_FILE_DELIVERY_OBJECT, assessmentRunId, deliveryObject };
    },
};

export default deliveringActions;
